module.exports = __webpack_public_path__ + "media/sfx_absorb.c84010f1.mp3";